import Section from "@/components/Section";
import { Box, Typography, useTheme } from "@mui/material";
import useResponsive from "@/hooks/useResponsive";
import Cars from "./components/Cars";
import Map from "../Map";
import { useEffect, useState } from "react";

const HeroSection = () => {
  const [reset, setReset] = useState<number>(1);
  const isMobile = useResponsive("down", "md");
  const theme = useTheme();

  const onChange = () => {
    return !document.hidden && setReset((prev) => prev + 1);
  };

  useEffect(() => {
    document.addEventListener("visibilitychange", onChange);

    return () => document.removeEventListener("visibilitychange", onChange);
  }, []);

  return (
    <Section
      pt={{ xs: 0, md: 6 }}
      pb={{ xs: 12.5, md: 25 }}
      sectionSx={{ position: "relative", overflow: "hidden" }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Box
          sx={{
            maxWidth: "780px",
            marginBottom: { xs: "78px", md: "120px" },
          }}
        >
          <Typography
            color={theme.palette.grey[800]}
            variant="h1"
            sx={{
              marginBottom: { xs: "16px", md: "24px" },
              textAlign: { xs: "start", md: "center" },
            }}
          >
            Why Trackmate?
          </Typography>
          <Typography
            variant="subtitle1"
            component="p"
            color={theme.palette.grey[600]}
            sx={{
              textAlign: { xs: "start", md: "center" },
            }}
          >
            We are the most affordable and reliable GPS tracking system, designed with all your necessary tools in one place.
          </Typography>
        </Box>
        <Box
          sx={{
            position: "relative",
            width: "100%",
            display: "flex",
            justifyContent: { xs: "end", md: "center" },
          }}
        >
          <Box
            sx={{
              position: "relative",
              width: "100%",
              height: { xs: "280px", md: "484px" },
              display: "flex",
              justifyContent: "center",
            }}
          >
            <Map key={reset} />
          </Box>
          <Box
            sx={{
              display: { xs: "none", md: "block" },
              width: "610px",
              height: "610px",
              backgroundColor: "rgba(255, 107, 0, 0.15)",
              filter: "blur(124px)",
              position: "absolute",
              top: "-100px",
              left: "45%",
            }}
          />
        </Box>
      </Box>
      {!isMobile ? <Cars /> : null}
    </Section>
  );
};

export default HeroSection;
